import React from "react";

const MidStickyCta = () =>{
  return(
    <div className="sticky-section midcta-valuation">
        <a href="/contact/property-valuation/" className="btn valuation-btn">BOOK A VALUATION</a>
        {/* <a href={`tel: 020 7370 4000`} className="btn  d-md-none">
        CHAT NOW <img src={baloon} alt="baloon-icon" className="baloon-icon"/></a> */}
    </div>
  )
}
export default MidStickyCta